import { memo, useState, useEffect, useRef } from 'react'
import styles from './index.module.scss'
import LogApi from '@/services/apis/log/index'
import { Button, DatePicker, Input, Table } from 'antd'
import { formatTime } from '@/utils/format'
import { useTranslation } from '@/services/i18n'
import SelectOption from '@/components/Select'
import classnames from 'classnames'
import MyTable from '@/components/Table'
import Shape from '@/assets/images/shape.png'
import { Dayjs } from 'dayjs'
import { LogConditionModel, LogItemModel, PageModel } from '@/services/apis/setting/module'
import dayjs from 'dayjs'
import { resetToStartTime, resetToEndTime } from '@/utils/number'

type RangeValue = [Dayjs | null, Dayjs | null] | null

const DAYS_LIMIT = 89

const { RangePicker } = DatePicker
const { Column } = Table
const { Search } = Input
const log = memo(() => {
  const { t } = useTranslation()

  const [dates, setDates] = useState<RangeValue>(null)
  const [selectedDates, setSelectedDates] = useState<RangeValue>([
    dayjs().subtract(DAYS_LIMIT, 'day'),
    dayjs(),
  ])

  const [queryParam, setQueryParam] = useState<any>({
    startTime: '',
    endTime: '',
    keyword: '',
    userKey: '',
    subjectType: '',
    eventType: '',
  })
  const disabledDate = (current: Dayjs) => {
    if (!dates) {
      return false
    }
    const isFuture = current?.isAfter(dayjs())
    if (isFuture) {
      return true
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') > DAYS_LIMIT
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > DAYS_LIMIT
    return !!tooEarly || !!tooLate
  }

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null])
    } else {
      setDates(null)
    }
  }

  const [listPage, setListPage] = useState<PageModel<LogItemModel>>({} as PageModel<LogItemModel>)
  const [conditon, setConditon] = useState<LogConditionModel>({
    subjectList: [],
    eventList: [],
    userList: [],
  })
  const [tableLoading, setTableLoading] = useState(false)
  // select选项
  const objectList = [...[{ code: '', name: t('auditLog.allObject') }], ...conditon.subjectList]
  const ActionList = [...[{ code: '', name: t('auditLog.allAction') }], ...conditon.eventList]
  const userList = [...[{ userKey: '', userName: t('auditLog.allUser') }], ...conditon.userList]
  const enterButton = (
    <Button style={{ width: '90px', height: '40px' }}>{t('record.search')}</Button>
  )
  // 获取select下拉框的数据
  async function getConditionData() {
    const res = await LogApi.getCondition()
    if (res.success) {
      setConditon(res.data)
    }
  }
  // 获取表格数据
  async function getRecordsList(page = 1) {
    console.log('queryParam:', queryParam)
    if (!queryParam.startTime || !queryParam.endTime) {
      return
    }

    setTableLoading(true)
    const params = {
      ...queryParam,
      pageIndex: page,
    }
    const res = await LogApi.getAuditLog(params)
    setTableLoading(false)
    if (res.success) {
      setListPage(res.data)
    }
  }

  // 日期发生改变
  useEffect(() => {
    const [startDate, endDate] = selectedDates ?? []

    if (startDate && endDate) {
      const startTime = resetToStartTime(dayjs(startDate).format())

      const endTime = resetToEndTime(dayjs(endDate).format())
      setQueryParam({ ...queryParam, endTime: endTime, startTime })
    }
  }, [selectedDates])

  // 通用方法改变搜索参数
  function handleChangeStatus(value: any, e: any, type: any) {
    queryParam[type] = value
    const DateList = { ...queryParam }
    setQueryParam(DateList)
  }
  function changePage(page: number) {
    getRecordsList(page)
  }
  // 展开行
  function isActive(item: Record<string, any>, key: string, subKey: string) {
    if (item['修改前'] && item['修改后']) {
      if (key === '修改前' && item['修改前'][subKey] !== item['修改后'][subKey]) {
        return true
      }
      return false
    }
    return false
  }
  const renderExpand = (record: LogItemModel) => {
    return (
      <div className={styles.expandRow}>
        <h3 style={{ marginTop: 0 }}>{t('auditLog.normalData')}</h3>
        <div className={styles.expandBox}>
          <div className={styles.row}>
            <div className={styles.label}>clientIp：</div>
            <div className={styles.desc}>{record.clientIp}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>userAgent：</div>
            <div className={styles.desc}>{record.userAgent}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>clientVersion：</div>
            <div className={styles.desc}>{record.clientVersion}</div>
          </div>
        </div>
        {Object.keys(record.eventDetail).length > 0 && (
          <h3 style={{ marginTop: '10px' }}>{t('auditLog.subData')}</h3>
        )}
        {Object.keys(record.eventDetail).length > 0 && (
          <div className={styles.expandBox}>
            {Object.keys(record.eventDetail).map(key => {
              return (
                <div className={styles.row} key={key}>
                  <div className={styles.label}>{key}:</div>
                  <div className={styles.desc}>{record.eventDetail[key]}</div>
                </div>
              )
            })}
          </div>
        )}
        <div className={styles.change_box}>
          {Object.keys(record.otherDetail).map((item, index) => {
            return (
              <div className={styles.change_item} key={index}>
                <h3 style={{ marginTop: '10px' }}>{item}</h3>
                {Object.keys(record.otherDetail[item]).map((subItem, index) => {
                  return record.otherDetail[item][subItem] ? (
                    <div key={index} className={styles.row}>
                      <div className={styles.label}>{subItem}:</div>
                      <div
                        className={classnames({
                          [styles.desc]: true,
                          [styles.active]: isActive(record.otherDetail, item, subItem),
                        })}
                        style={{ maxWidth: '250px' }}
                      >
                        {record.otherDetail[item][subItem]}
                      </div>
                    </div>
                  ) : null
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  useEffect(() => {
    getRecordsList()
  }, [queryParam])
  useEffect(() => {
    getConditionData()
  }, [])
  // 处理前三个月后三个月
  const pickerRef = useRef<any>(null)
  function handleMonths(type: 1 | 0) {
    // 前三个月
    if (type) {
      setSelectedDates([
        dayjs(selectedDates![0]).add(-3, 'month'),
        dayjs(selectedDates![1]).add(-3, 'month'),
      ])
    } else {
      setSelectedDates([
        dayjs(selectedDates![0]).add(3, 'month'),
        dayjs(selectedDates![1]).add(3, 'month'),
      ])
    }
    pickerRef.current.blur()
  }
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <RangePicker
          allowClear={false}
          disabledDate={disabledDate}
          value={dates || selectedDates}
          onChange={value => {
            setSelectedDates(value)
          }}
          onOpenChange={onOpenChange}
          onCalendarChange={val => {
            setDates(val)
          }}
          size="middle"
          style={{ marginLeft: '10px', height: '40px' }}
          changeOnBlur
          renderExtraFooter={() => (
            <div className={styles.months}>
              <Button type="link" style={{ marginRight: '10px' }} onClick={() => handleMonths(1)}>
                {t('common.firstThreeMonths')}
              </Button>
              <Button
                type="link"
                onClick={() => handleMonths(0)}
                disabled={+dayjs(queryParam.endTime).add(3, 'month') >= +dayjs()}
              >
                {t('common.nextThreeMonths')}
              </Button>
            </div>
          )}
          ref={pickerRef}
        />
        <SelectOption
          list={objectList}
          type="subjectType"
          handleSetDate={handleChangeStatus}
          fieldName={{ label: 'name', value: 'code' }}
        />
        <SelectOption
          list={ActionList}
          type="eventType"
          handleSetDate={handleChangeStatus}
          fieldName={{ label: 'name', value: 'code' }}
        />
        <SelectOption
          list={userList}
          type="userKey"
          handleSetDate={handleChangeStatus}
          fieldName={{ label: 'userName', value: 'userKey' }}
        />
        <Search
          placeholder={'txKey'}
          enterButton={enterButton}
          style={{ width: '300px', marginLeft: '10px' }}
          onSearch={(value, event) => {
            handleChangeStatus(value, event, 'keyword')
          }}
          size="small"
        />
      </div>
      {/* 总数大于每页条数 */}

      <MyTable
        dataSource={listPage?.content}
        loading={tableLoading}
        pagination={{
          pageSize: listPage.pageSize,
          total: listPage?.totalElements,
          showSizeChanger: false,
          hideOnSinglePage: true,
          onChange: changePage,
        }}
        rowKey="id"
        expandable={{
          expandedRowRender: renderExpand,
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  <img
                    src={Shape}
                    alt=""
                    style={{ width: '10px', height: 'auto', transform: 'rotate(180deg)' }}
                  />
                </div>
              </div>
            ) : (
              <div onClick={e => onExpand(record, e)} className={styles.expand}>
                <div style={{ marginRight: '5px' }}>{t('record.detail')}</div>
                <div>
                  {' '}
                  <img src={Shape} alt="" style={{ width: '10px', height: 'auto' }} />
                </div>
              </div>
            ),
          expandIconColumnIndex: 5,
          columnWidth: '600px',
        }}
        bottomY={70}
      >
        <Column title={t('auditLog.time')} render={recoder => formatTime(recoder.gmtCreate)} />
        <Column title={t('auditLog.object')} dataIndex="subjectType" />
        <Column title={t('auditLog.action')} dataIndex="eventType" />
        <Column title={t('auditLog.user')} dataIndex="triggerUserName" />
      </MyTable>
    </div>
  )
})

export default log
